import { useMutation } from '@tanstack/react-query'
import axios from 'axios'
import { CreditCardListResponse } from 'src/models/creditCard.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'
import { PostCreditCardSuccessPayload } from 'src/redux/actions/data/creditCards.actions'
import { PostCreditCardRequest } from 'src/requests/postCreditCard.request'

type PostCreditCardV2Request = PostCreditCardRequest & {
  cardholderName: string
  cvc: string
}

// INCOMPLETE TYPE. Only grabbing what we need from here
// for the time being
type PostCreditCardV2Response = {
  creditCard: {
    id: string
  }
}

/**
 * Create a stub credit card to be verified later via PUT and 3DS verification for
 * physical cards
 * @API_TYPE - vgs.paywithextend.com
 * @endpoint POST /creditcardsv2
 * @params options
 */
export function usePostCreditCardV2() {
  const mutation = useMutation({
    mutationFn: async (body: Partial<PostCreditCardV2Request>) => {
      // Use VGS subdomain instead. Figure out how environments work to do this
      // since the subdomain changes
      const response = await axios.post<Partial<PostCreditCardSuccessPayload>>(
        '/creditcardsv2',
        body,
        getRequestConfig(RequestConfig.Vault),
      )

      return response.data as PostCreditCardV2Response
    },
  })

  return mutation
}

/**
 * @API_TYPE - api.paywithextend.com
 * @returns
 */
export function usePutCreditCardV2() {
  const mutation = useMutation({
    mutationFn: async (options: {
      creditCardId: string
      endpoint: 'virtual' | 'physical'
    }) => {
      const { creditCardId, endpoint } = options
      const response = await axios.put(
        `/creditcardsv2/${creditCardId}/${endpoint}`,
        {},
        getRequestConfig(),
      )

      return response.data
    },
  })

  return mutation
}
/**
 * Deactivates a physical card from the Astrada integration feed
 * @returns
 */
export function useDeactivatePhysicalCard() {
  const mutation = useMutation({
    mutationFn: async (
      creditCardId: string,
    ): Promise<CreditCardListResponse> => {
      const authedConfig = getRequestConfig()
      // axios.put was acting weird so putting in this way is working as expected
      const response = await axios.request({
        ...authedConfig,
        method: 'PUT',
        headers: {
          ...authedConfig.headers,
        },
        url: `/creditcardsv2/${creditCardId}/deactivate`,
      })
      const data = response.data

      return data
    },
  })

  return mutation
}
